import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import i18next from "i18next";
import {I18nextProvider} from "react-i18next";
import common_hay from "./translation/hay/common.json";
import common_en from "./translation/en/common.json";
import common_ru from "./translation/ru/common.json";


i18next.init({
    interpolation: {escapeValue: false},
    lng: 'hay',
    resources: {
        hay:{
            common: common_hay,
        },
        en:{
            common: common_en,
        },
        ru:{
            common: common_ru,
        }
    }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <I18nextProvider i18n={i18next}>
            <App/>
       </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
